import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useMemo } from "react";
import { useAppLocale } from "./LocaleContext";
import { actionCopyEn } from "@patient-watch/i18n/webapp/en-GB/actionCopy";
import { actionCopyDe } from "@patient-watch/i18n/webapp/de-DE/actionCopy";
import { actionCopyDa } from "@patient-watch/i18n/webapp/da-DK/actionCopy";
import { actionCopyEnUs } from "@patient-watch/i18n/webapp/en-US/actionCopy";
import { actionCopyFr } from "@patient-watch/i18n/webapp/fr-FR/actionCopy";
import { actionCopyIt } from "@patient-watch/i18n/webapp/it-IT/actionCopy";
import { actionCopyEs } from "@patient-watch/i18n/webapp/es-ES/actionCopy";

/** Standard action and control labels used across the app. */
export interface ActionCopy {
    next: string;
    back: string;
    save: string;
    send: string;
    skip: string;
    skipForNow: string;
    continue: string;
    cancel: string;
    delete: string;
    submit: string;
    confirm: string;
    add: string;
    edit: string;
    done: string;
    stop: string;
    retry: string;
    download: string;
    apply: string;
    filter: string;
    filters: string;
    columns: string;
    close: string;
    search: string;
    more: string;
    none: string;
    previous: string;
    rename: string;
    duplicate: string;
    share: string;
    clearAll: string;
    clearSearch: string;
    loading: string;
    open: string;
    invite: string;
    saveCorrection: string;
    saving: string;
    sending: string;
    submitting: string;
    skipping: string;
    goingBack: string;
    goingNext: string;
    cancelling: string;
    deleting: string;
    deleteConfirmTitle: string;
    deleteConfirmDescription: string;
    continuing: string;
    confirming: string;
    adding: string;
    editing: string;
    finishing: string;
    stopping: string;
    retrying: string;
    downloading: string;
}

const actionCopy: Record<SupportedLocale, ActionCopy> = {
    "en-GB": actionCopyEn,
    "en-US": actionCopyEnUs,
    "de-DE": actionCopyDe,
    "da-DK": actionCopyDa,
    "fr-FR": actionCopyFr,
    "it-IT": actionCopyIt,
    "es-ES": actionCopyEs,
};

export function getActionCopy(locale: SupportedLocale): ActionCopy {
    return pickAppCopy(actionCopy, locale);
}

export function useActionCopy(): ActionCopy {
    const { locale } = useAppLocale();
    return useMemo(() => getActionCopy(locale), [locale]);
}
